import { environment } from '../../environments/environment';

export class AppSettings {
  public static URL_GLOBAL: string = environment.URL_GLOBAL;

}

let URL_GLOBAL: string = environment.URL_GLOBAL;
let URL_GLOBAL_REPORTES: string = environment.URL_GLOBAL_REPORTES;

export const REST_SERVICES = {
  search_prevencion: URL_GLOBAL + '/search/prevencion/bines',
  BUSQUEDA_CIFRAS_CONTROL: URL_GLOBAL + '/search/cifrasControl?idTipoArchivo=',
  BUSQUEDA_CIFRAS_CONTROL_DETALLE: URL_GLOBAL + '/search/cifrasControl/detail?idArchivoBatch=',
  BUSQUEDA_EJECUTOR: URL_GLOBAL + '/search/ejecutor/bines',
  BUSQUEDA_EJECUTOR_CONTROL: URL_GLOBAL + '/search/ejecutor/binesControl',
  BUSQUEDA_BIN_MANAGER: URL_GLOBAL + '/binManager/bines',
  ACTUALIZAR_BINES_BIN_MANAGER: URL_GLOBAL + '/binesBase/binManagerUpdate',
  BUSQUEDA_ALERTAS: URL_GLOBAL + '/alerts',
  BUSQUEDA_TOTAL_ALERTAS: URL_GLOBAL + '/alerts/resumen',
  DESACTIVAR_ALERTA: URL_GLOBAL + '/alerts/checkView?id=',
  ACTIVAR_CONTINGENCIA: URL_GLOBAL + '/activarContingencia',
  BUSCAR_COMENTARIO: URL_GLOBAL + '/search/lastComment?idBin=',
  DELETE_PROCESADOR: URL_GLOBAL + '/procesadores',
  NUEVO_PROCESADOR: URL_GLOBAL + '/procesadores',
  BUSQUEDA_PROCESADOR: URL_GLOBAL + '/procesadores/search',
  BUSQUEDA_INSTITUCION: URL_GLOBAL + '/instituciones/search',
  ACTUALIZAR_PROCESADOR: URL_GLOBAL + '/procesadores',
  NUEVA_INSTITUCION: URL_GLOBAL + '/instituciones',
  DELETE_INSTITUCION: URL_GLOBAL + '/instituciones',
  ACTUALIZAR_INSTITUCION: URL_GLOBAL + '/instituciones',
  search_supervisor: URL_GLOBAL + '/search/supervisor/bines',

  unlock_bin_prevencion: URL_GLOBAL + '/desbloqueoBin',
  lock_bin_prevencion: URL_GLOBAL + '/bloqueoBin',

  BLOQUEO_BIN_SUPERVISOR: URL_GLOBAL + '/binesGenerales/block',
  DESBLOQUEO_BIN_SUPERVISOR: URL_GLOBAL + '/binesGenerales/unblock',

  search_bitacora_movimientos: URL_GLOBAL + '/search/bitacoraMovimientos',


  CHECK_REFUSE_BIN: URL_GLOBAL + '/binesGenerales/checkRefuseBin',
  BUSQUEDA_VALORES_BITACORA: URL_GLOBAL + '/busquedaValoresBitacora?id=',
  search_catalogos: URL_GLOBAL + '/getCatalogos',

  BUSQUEDA_BIN_EMISION_NACIONAL: URL_GLOBAL + '/BinesEmiNacionales/search?id=',
  BUSQUEDA_BIN_ADQ_NACIONAL: URL_GLOBAL + '/BinesAdqNac/search?id=',
  BUSQUEDA_BIN_EMI_EGLOBAL: URL_GLOBAL + '/BinesEmiEglobal/search?id=',
  BUSQUEDA_BIN_BNMX: URL_GLOBAL + '/BinesBnmx/search?id=%i&idTipoBin=%t',
  BUSQUEDA_BIN_BBVA: URL_GLOBAL + '/BinesBBVA/search?id=%i&idTipoBin=%t',
  BUSQUEDA_BIN_MASTERCARD: URL_GLOBAL + '/BinesMastercard/search?id=',

  ACTUALIZAR_BIN_EMISION_NACIONAL: URL_GLOBAL + '/BinesEmiNacionales/update?id=',
  BIN_ALTA_BASE: URL_GLOBAL + '/binesGenerales',
  BIN_CONSULTA_BASE: URL_GLOBAL + '/binesGenerales?id=',
  ACTUALIZAR_BIN_ADQ_NACIONAL: URL_GLOBAL + '/BinesAdqNac/update?id=',
  ACTUALIZAR_BIN_EMI_EGLOBAL: URL_GLOBAL + '/BinesEmiEglobal/update?id=',
  ACTUALIZAR_BIN_BNMX: URL_GLOBAL + '/BinesBnmx/update?id=%i&idTipoBin=%t',
  ACTUALIZAR_BIN_BBVA: URL_GLOBAL + '/BinesBBVA/update?id=%i&idTipoBin=%t',
  ACTUALIZAR_BIN_MASTERCARD: URL_GLOBAL + '/BinesMastercard/update?id=',

  CONSULTAR_USUARIO: URL_GLOBAL + '/users/getUser?username=',
  CATALOGO_ACCION: URL_GLOBAL + "/getCatalogoAccion",
  CATALOGO_ESTATUS: URL_GLOBAL + "/getCatalogoEstatus",
  CATALOGO_TIPO_BIN: URL_GLOBAL + "/getCatalogoTipoBin",
  CATALOGO_INSTITUCIONES: URL_GLOBAL + "/getCatalogoInstituciones?idTipoBin=%id",
  CATALOGO_INSTITUCIONES_ID: URL_GLOBAL + "/getCatalogoInstitucionesAltaBin?idTipoBin=%id%ins",
  CATALOGO_INSTITUCIONES_COMPLETO: URL_GLOBAL + "/getCatalogoInstitucionesCompleto",
  CATALOGO_PROCESADORES: URL_GLOBAL + "/getCatalogoProcesadores",
  CATALOGO_MARCA: URL_GLOBAL + "/getCatalogoMarcaProducto",
  CATALOGO_NATURALEZA: URL_GLOBAL + "/getCatalogoNaturalezaBines",
  CATALOGO_ESQUEMAS: URL_GLOBAL + "/getCatalogoEsquemas",
  CATALOGO_PLANTILLAS: URL_GLOBAL + "/getCatalogoPlantillas",
  CATALOGO_SECCIONES: URL_GLOBAL + "/getCatalogoSecciones",
  CATALOGO_TIPO_CAMPO: URL_GLOBAL + "/getCatalogoTipoCampos",
  /*BUSQUEDA_CAMPOS_PLANTILLA : URL_GLOBAL + "/binesBase?idTipoBin=%it&idInstitucion=%i&bin=%b",*/
  BUSQUEDA_CAMPOS_PLANTILLA: URL_GLOBAL + "/binesBase/binManager",

  BUSQUEDA_CAMPOS_PLANTILLA_BIN_MANAGER: URL_GLOBAL + "/binManager/bines",
  GUARDAR_CAMPOS_PLANTILLA: URL_GLOBAL + "/binesBase",
  BUSQUEDA_BIN_BY_ID: URL_GLOBAL + "/binesBase/binSaved?idBin=%id&origenInfo=%origen&grupo=%grupo",
  BUSQUEDA_BIN_BY_ID_POST: URL_GLOBAL + "/binesBase/binSavedBinManager",
  ELIMINAR_BIN: URL_GLOBAL + "/binesGenerales/delete",
  SUSPENDER_BIN: URL_GLOBAL + "/binesGenerales/suspend",
  DEPURAR_BIN: URL_GLOBAL + "/binesGenerales/depurar",
  // REPORTES
  EXPORTAR_EXCEL_MOVIMIENTOS_AUTOMATICOS: URL_GLOBAL_REPORTES + "/reporte/movimientosAutomaticos",
  MOVIMIENTOS_AUTOMATICOS_CONSULTA: URL_GLOBAL_REPORTES + "/reporte/movimientosAutomaticosConsulta",
  EXPORTAR_EXCEL_EMISOR_NACIONAL: URL_GLOBAL_REPORTES + "/reporte/emisorNacional",
  EXPORTAR_EXCEL_EMISOR_EGLOBAL: URL_GLOBAL_REPORTES + "/reporte/emisoreglobal",
  EXPORTAR_EXCEL_EMISOR_ESPECIAL : URL_GLOBAL_REPORTES + "/reporte/binesEspeciales",
  EXPORTAR_EXCEL_ADQUIRENTE_NACIONAL: URL_GLOBAL_REPORTES + "/reporte/adquirenteNacional",
  EXPORTAR_EXCEL_EMISOR_INTERNACIONAL: URL_GLOBAL_REPORTES + "/reporte/emisorInternacional",
  EXPORTAR_EXCEL_BIN_MANAGER: URL_GLOBAL_REPORTES + "/reporte/binManager",
  DOWNLOAD_REPORTE: URL_GLOBAL_REPORTES + "/reporte/downloadb64?reporte=",
  EXPORTAR_EXCEL_ELIMINADOS_HISTORICO: URL_GLOBAL_REPORTES + "/reporte/eliminadosHistorico",
  EXPORTAR_EXCEL_BITACORA_MOVIMIENTOS: URL_GLOBAL_REPORTES + "/reporte/bitacoraMovimientos",
  EXPORTAR_EXCEL_BINESALTA_PENDIENTES: URL_GLOBAL_REPORTES + "/reporte/binesPendientesAlta",
  CIFRAS_CONTROL_BINESALTA_PENDIENTES: URL_GLOBAL_REPORTES + "/consulta/cifrasBinesPendientesAlta",
  
  //ESQUEMAS
  BUSQUEDA_ESQUEMAS: URL_GLOBAL + "/esquemas/search",
  NUEVO_ESQUEMA: URL_GLOBAL + '/esquemas',
  DELETE_ESQUEMA: URL_GLOBAL + '/esquemas',
  ACTUALIZAR_ESQUEMA: URL_GLOBAL + '/esquemas',

  //CAMPOS
  BUSQUEDA_CAMPOS: URL_GLOBAL + "/campos/search",
  NUEVO_CAMPO: URL_GLOBAL + '/campos',
  DELETE_CAMPOS: URL_GLOBAL + '/campos',
  ACTUALIZAR_CAMPOS: URL_GLOBAL + '/campos',

  //PLANTILLAS
  BUSQUEDA_PLANTILLAS: URL_GLOBAL + "/plantillas/search",
  NUEVA_PLANTILLA: URL_GLOBAL + '/plantillas',
  ELIMINAR_PLANTILLA: URL_GLOBAL + '/plantillas',
  ACTUALIZAR_PLANTILLA: URL_GLOBAL + '/plantillas',

   //PLANTILLAS
   BUSQUEDA_SECCIONES: URL_GLOBAL + "/secciones/search",
   NUEVA_SECCION: URL_GLOBAL + '/secciones',
   ELIMINAR_SECCION: URL_GLOBAL + '/secciones',
   ACTUALIZAR_SECCION: URL_GLOBAL + '/secciones',
   
   //CONFIGURACIONES_ESQUEMA
   BUSQUEDA_CONFIGURACIONES_ESQUEMA: URL_GLOBAL + "/configEsquema/search",
   NUEVA_CONFIGURACION_ESQUEMA: URL_GLOBAL + '/configEsquema',
   ELIMINAR_CONFIGURACION_ESQUEMA: URL_GLOBAL + '/configEsquema/delete',
   ACTUALIZAR_CONFIGURACION_ESQUEMA: URL_GLOBAL + '/configEsquema',
   
  // CHECK BIN - CAMPOS MODIFICADOS
  BUSQUEDA_CAMPOS_MODIFICADOS_BIN: URL_GLOBAL + "/search/fieldsModified",

  // MAKER CHECKER INSTITUCIONES
  CREAR_OPERACION_INSTITUCION: URL_GLOBAL + '/instituciones/operaciones',
  LISTAR_OPERACIONES_PENDIENTES: URL_GLOBAL + '/instituciones/operaciones/pendientes',
  AUTORIZAR_OPERACION: URL_GLOBAL + '/instituciones/operaciones/:id/autorizar',
  RECHAZAR_OPERACION: URL_GLOBAL + '/instituciones/operaciones/:id/rechazar',
  BUSQUEDA_INSTITUCION_ID: URL_GLOBAL + '/instituciones/search?id=%id',
  BUSQUEDA_INSTITUCION_PAGINADO: URL_GLOBAL + '/instituciones/paginado',

  getBusquedaBin: function (idTipoBin: number) {
    switch (idTipoBin) {
      case 1: return REST_SERVICES.BUSQUEDA_BIN_EMISION_NACIONAL;
      case 2: return REST_SERVICES.BUSQUEDA_BIN_ADQ_NACIONAL;
      case 3: return REST_SERVICES.BUSQUEDA_BIN_EMI_EGLOBAL;
      case 4: return REST_SERVICES.BUSQUEDA_BIN_BNMX;
      case 5: return REST_SERVICES.BUSQUEDA_BIN_BBVA;
      case 6: return REST_SERVICES.BUSQUEDA_BIN_MASTERCARD;
    }
  }

}

